// =============================================================================
// client/src/lib/flux/status.js | v1.0 | S79 | P9a — W-7(e)
// =============================================================================
// The badge colour dictionary, and NOTHING else.
//
// 🔴 KEYED ON status_display.severity AND NOTHING ELSE. Not on pause_reason,
// not on status, not on a substring of a label. The server decided the state
// (server/src/lib/flux-status.js, W-1); this file decides only how it looks —
// the server-vs-client rule adopted 2026-08-17.
//
// A client that reads pause_reason to pick a colour is the RecruitMail defect
// this phase exists to delete: RM decoded state in the browser, in two copies,
// and they drifted.
//
// Hues are the ones already in use — PlanProgress.jsx's PLAN_STATUS_COLORS and
// RecruitList.jsx's recruit-pipeline statuses. P9a adds no theme token, and
// `silver-text` is an existing token in client/tailwind.config.js.
// =============================================================================

export const SEVERITY_CLASSES = {
  red: 'bg-red-200 text-red-800',
  orange: 'bg-amber-100 text-amber-800',
  green: 'bg-green-100 text-green-800',
  blue: 'bg-blue-100 text-blue-800',
  gray: 'bg-gray-200 text-silver-text',
};

// An unknown severity is a server that shipped a new one, or a response from a
// server that has not deployed W-1 yet. Render it neutrally rather than blank —
// never crash, and never guess a colour from some other field.
export function severityClass(severity) {
  return SEVERITY_CLASSES[severity] || SEVERITY_CLASSES.gray;
}

// Sort helper for a page of campaigns. The RANK IS THE SERVER'S
// (status_display.sort_rank); this only applies it, then breaks ties on the
// recruit name the way RM did. In-page only — the list is one page of 100 and
// a cross-page sort would be a client computing an order over data it does not
// have (B-25's shape).
export function bySortRankThenRecruit(a, b) {
  const ra = a?.status_display?.sort_rank ?? 99;
  const rb = b?.status_display?.sort_rank ?? 99;
  if (ra !== rb) return ra - rb;
  return String(a?.recruitName || '').localeCompare(String(b?.recruitName || ''));
}
